/**
 * @author       jose.lucena@zumper.com (José Lucena)
 * @copyright    Copyright (c) 2025, Zumper
 */

export const DONE_FETCHING_RENT_RESEARCH = '@@nzr/rentResearch/DONE_FETCHING_RENT_RESEARCH'
export const ERROR_FETCHING_RENT_RESEARCH = '@@nzr/rentResearch/ERROR_FETCHING_RENT_RESEARCH'
export const RECEIVE_RENT_RESEARCH = '@@nzr/rentResearch/RECEIVE_RENT_RESEARCH'
export const START_FETCHING_RENT_RESEARCH = '@@nzr/rentResearch/START_FETCHING_RENT_RESEARCH'
